module.exports = __webpack_public_path__ + "static/media/vf_mdressshoes_core.2d3e5a2e.svg";